import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PostBacDatabase from './pages/post-bac-database';
import AdmissionCalendar from './pages/admission-calendar';
import LyceeOrientation from './pages/lycee-orientation';
import StudentProfile from './pages/student-profile';
import InstitutionDetails from './pages/institution-details';
import Homepage from './pages/homepage';
import Auth from './pages/Auth';
import DeadlinesPage from './pages/DeadlinesPage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Page d'accueil par défaut (j'ai mis Homepage ici) */}
          <Route path="/" element={<Homepage />} />

          {/* Les autres pages */}
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/post-bac-database" element={<PostBacDatabase />} />
          <Route path="/admission-calendar" element={<AdmissionCalendar />} />
          <Route path="/lycee-orientation" element={<LyceeOrientation />} />
          <Route path="/student-profile" element={<StudentProfile />} />
          <Route path="/institution-details" element={<InstitutionDetails />} />
          <Route path="/calendrier-admissions" element={<DeadlinesPage />} />

          {/* --- LES NOUVELLES ROUTES DE CONNEXION --- */}
          <Route path="/login" element={<Auth />} />
          <Route path="/register" element={<Auth />} />

          {/* Page 404 (toujours à la fin) */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;